import { useQuery } from '@tanstack/react-query';
import { pipe } from 'ramda';
import { AuthorizedBaseAxios, flatten } from 'src/config/axios';
import { verificationQueryKeys } from 'src/common/verificationQueryKeys';
import { ValueWrapper, extractValue } from 'src/utils/extractValue';
import { publicApiPath } from 'src/common/publicApiPath';

const getPartnerLogo = (verificationId: string) =>
  AuthorizedBaseAxios.get<ValueWrapper<string>>(
    `${publicApiPath}/logo/${verificationId}`
  ).then(pipe(flatten, extractValue));

export const useGetPartnerLogoQuery = ({
  verificationId,
  enabled,
}: {
  verificationId?: string;
  enabled: boolean;
}) => {
  return useQuery(
    verificationQueryKeys.partnerLogo(verificationId),
    () => (verificationId ? getPartnerLogo(verificationId) : undefined),
    {
      enabled: enabled && Boolean(verificationId),
    }
  );
};
